import { useMemo } from 'react';
import type {
  UpgradeOpenInput,
  UpgradeOpenOverrides,
} from '../lib/upgrade-routing';
import { buildUpgradeDialogProps } from '../lib/upgrade-routing';
import { useDialog } from './DialogProvider';

export function useUpgradeModal() {
  const { open } = useDialog();

  // Stable like the native twin's useCallback, so callers can list it as a
  // hook dependency without re-creating their handlers every render.
  return useMemo(
    () => ({
      open: (input?: UpgradeOpenInput, overrides?: UpgradeOpenOverrides) =>
        open('upgrade', buildUpgradeDialogProps(input, overrides)),
    }),
    [open],
  );
}
